/**
 * GraphQL fragments for Schedule primitive
 *
 * Complete field coverage: 40 fields in 8 categories
 * Supports: 6 queries + 6 mutations + 3 subscriptions
 */

import { gql } from '@apollo/client';

/**
 * Core Schedule fields fragment - All 40 fields organized by category
 */
export const SCHEDULE_FIELDS = gql`
  fragment ScheduleFields on Schedule {
    # 1. Identity Fields (4)
    scheduleId
    tenantId
    scheduleName
    scheduleCode

    # 2. Formula Interactions Fields (6)
    targetTaskIds
    targetWorkflowInstanceId
    slaDeadlineEnforcementIds
    notificationIds
    analyticsOptimizationEnabled
    actorAvailabilityTrackingIds

    # 3. Schedule Configuration Fields (10)
    scheduleType
    scheduleStatus
    schedulePriority
    startDatetime
    endDatetime
    maxExecutions
    currentExecutionCount
    lastExecutionAt
    nextExecutionAt
    executionWindowMinutes

    # 4. Cron Expression Fields (2)
    cronExpression
    timezone

    # 5. Life-Critical Fields (6)
    isLifeCritical
    clinicalScheduleType
    safetyWindowMinutes
    escalationOnMissMinutes
    caregiverNotificationIds
    clinicalOverrideAllowed

    # 6. Rate Limiting Fields (4)
    rateLimitPerHour
    dailyExecutionQuota
    monthlyExecutionQuota
    quotaExceededAction

    # 7. Reliability Fields (4)
    retryOnFailure
    maxRetryAttempts
    consecutiveFailures
    failureAction

    # 8. Audit Fields (4)
    createdAt
    createdBy
    updatedAt
    updatedBy

    # Extended Metadata
    extendedMetadata
  }
`;

/**
 * Schedule connection fragment for paginated queries
 */
export const SCHEDULE_CONNECTION_FIELDS = gql`
  ${SCHEDULE_FIELDS}
  fragment ScheduleConnectionFields on ScheduleConnection {
    items {
      ...ScheduleFields
    }
    total
    nextCursor
    hasMore
  }
`;

/**
 * Schedule execution summary fragment for performance metrics
 */
export const SCHEDULE_EXECUTION_SUMMARY_FIELDS = gql`
  fragment ScheduleExecutionSummaryFields on ScheduleExecutionSummary {
    scheduleId
    totalExecutions
    successfulExecutions
    failedExecutions
    missedExecutions
    averageExecutionTimeMs
  }
`;
